export default __webpack_public_path__ + "static/guesty-icon-ac3bcbb3ce3547a273294e1cd799dac4.svg";